import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShieldAlt,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

// Este componente solo recibe props y renderiza el JSX. No tiene lógica propia.
const AgeGateModal = ({ onConfirm, onExit }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm">
      <div className="w-full max-w-md p-6 sm:p-8 mx-4 bg-white dark:bg-neutral-800 rounded-2xl shadow-2xl text-center transform transition-all">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className="text-5xl text-amber-400 mb-4"
        />

        <h2 className="font-display text-2xl sm:text-3xl font-bold text-neutral-900 dark:text-white mb-2">
          {t('age_gate.title')}
        </h2>

        <p className="text-neutral-600 dark:text-neutral-300 mb-6">
          {t('age_gate.message')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={onConfirm}
            className="w-full btn-primary text-base font-bold py-3"
          >
            {t('age_gate.confirm_button')}
          </button>
          <button
            onClick={onExit}
            className="w-full btn-secondary text-base font-bold py-3"
          >
            {t('age_gate.exit_button')}
          </button>
        </div>

        <div className="mt-6 text-xs text-neutral-500 dark:text-neutral-400">
          <FontAwesomeIcon icon={faShieldAlt} className="mr-1" />
          {t('age_gate.legal_notice')}
        </div>
      </div>
    </div>
  );
};

export default AgeGateModal;
